module.exports = __webpack_public_path__ + "static/media/map-marker-alt.33f1229e.svg";